import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import customizationReducer from "./customizationReducer";
import accountReducer from "./accountReducer";
import autoCompleteReducer from "./autoCompleteReducer";

const reducer = combineReducers({
  account: persistReducer(
    {
      key: "account",
      storage,
      keyPrefix: "lemken-"
    },
    accountReducer
  ),
  accountDefault: accountReducer,
  customization: customizationReducer,
  autoComplete: autoCompleteReducer
});

export default reducer;
